import { appConfig, headerConfig, refineHeader } from "../../config";

export const questionService = {
  get_question_details,
  get_question_list,
  add_question,
  delete_question,
  add_answer
};

function add_question(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}question/ask-question`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function add_answer(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}question/answer-question`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function get_question_list(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}question/list`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function delete_question(quesID) {
  refineHeader();
  const requestOptions = {
    method: "DELETE",
    headers: headerConfig.headerDatas,
    mode: "cors",
    // body: JSON.stringify()
  };

  return fetch(`${appConfig.api.url}question/delete/${quesID}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function get_question_details(quesID) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors"
  };

  return fetch(`${appConfig.api.url}question/detail/${quesID}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}



// WEBPACK FOOTER //
// ./src/app/services/API/questionService.js